var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageNavigation',{attrs:{"tabs":_vm.allTabs}})
}
var staticRenderFns = []

export { render, staticRenderFns }